'use strict';

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Iframe from '../../IFrame';
import Loader from '../../Loader';
import Api from '../../../api/Api';
import Urls from '../../../definitions/Urls';
import iFrameNavigationListener from '../../../listener/iFrameNavigationListener';
import { QUESTIONNAIRES } from '../../../data/reducer';
import { getQuestionnaires } from '../../../data/questionnaires/actions';
import { setLastActive } from '../../../data/session/actions';

class Questionnaire extends React.Component {
  constructor(props) {
    super(props);

    // initialize trusted context as empty
    this.state = { trustedContext: '', iframeStatus: null };
    this.queryBaseUrl =
      Urls.medixineApi() + '/signin-trustedcontext-fi?_trustedContextToken=';
  }

  static willTransitionFrom(component, transition) {
    if (!window.confirm('Are you sure you want to leave ?')) {
      transition.abort();
    }
  }

  componentDidMount() {
    // when component mounts, get recent trusted context.
    Api.getTrustedContext().then((ctx) => {
      this.setState({ trustedContext: ctx });
    });
    window.addEventListener(
      'message',
      iFrameNavigationListener(this.props.setLastActive)
    );
  }

  /*
   * When we move away from filling a carerequest, we do not know anything from it's state since it's in an iframe.
   * This is why we need to update/fetch new state of carerequests when we leave view. Questionnaires are handled
   * from the root component so the function is passed as props
   * */
  componentWillUnmount() {
    this.props.getQuestionnaires();
    window.removeEventListener('message', iFrameNavigationListener);
  }

  iframeLoaded = () => {
    this.setState({ iframeStatus: 'loaded' });
  };

  render() {
    let result = null;
    if (
      this.props.data &&
      this.props.data.medixine &&
      (this.props.data.medixine.completed ||
        this.props.data.medixine.started ||
        this.props.data.medixine.modifiable)
    ) {
      result = (
        this.props.data.medixine.completed
          ? this.props.data.medixine.completed
          : []
      )
        .concat(this.props.data.medixine.started)
        .concat(this.props.data.medixine.modifiable)
        .filter(
          (questionnaire) =>
            questionnaire.link ===
            '/edit/' +
              this.props.match.params.formOID +
              '/' +
              this.props.match.params.patientOID +
              '/' +
              this.props.match.params.answerOID
        )[0];
    }

    let url =
      result && this.state.trustedContext
        ? this.queryBaseUrl.concat(
            this.state.trustedContext,
            '&ReturnUrl=',
            encodeURIComponent(
              '/QuestionnaireAnswer/' +
                this.props.match.params.formOID +
                '/' +
                this.props.match.params.patientOID +
                '/' +
                (result.status === 'COMPLETED' || result.status === 'MODIFIABLE'
                  ? 'Review'
                  : 'ContinueAnswering') +
                '?AnswerOID=' +
                this.props.match.params.answerOID
            )
          )
        : '';

    return (
      <div className="ot-mainview">
        {this.state.iframeStatus === null && <Loader />}
        <Iframe
          ref="frame"
          url={url}
          width="100%"
          height="1000px"
          display="initial"
          position="relative"
          allowFullScreen
          onLoad={() => this.iframeLoaded()}
        />
      </div>
    );
  }
}

Questionnaire.propTypes = {
  match: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired,
  getQuestionnaires: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    data: state[QUESTIONNAIRES].data,
  };
};

export default connect(mapStateToProps, { getQuestionnaires, setLastActive })(
  Questionnaire
);
